import { useState } from "react";
import { useTranslation } from "../../localization/useTranslation";
import { AddToAllDialogState, AddToAllDialogType, createInitialState } from "./AddToAllDataCategoriesDialog.types";

export function AddToAllDataCategoriesDialogHooks() {
    const { translateString } = useTranslation();
    const [state, setState] = useState<AddToAllDialogState>(createInitialState());

    function showDialogForType(type: AddToAllDialogType, entityId: string) {
        if (state[type].displayOnClick) {
            setState((prev) => ({
                ...prev,
                [type]: { ...prev[type], isDisplayed: true },
                selectedEntityId: entityId,
            }));
        }
    }

    function hideDialog(displayOnClick: boolean) {
        setState((prev) => {
            const newState = { ...prev };
            const types: AddToAllDialogType[] = ["directive", "nationalLaw", "doubleLegalBasis", "deletionPeriod"];
            for (const type of types) {
                if (newState[type].isDisplayed) {
                    newState[type] = { displayOnClick, isDisplayed: false };
                    break;
                }
            }
            newState.selectedEntityId = "";
            return newState;
        });
    }

    function isDialogVisible(): boolean {
        return state.directive.isDisplayed || state.nationalLaw.isDisplayed || state.doubleLegalBasis.isDisplayed || state.deletionPeriod.isDisplayed;
    }

    function getDialogType(): string {
        if (state.deletionPeriod.isDisplayed) return translateString("deletionPeriod");
        if (state.directive.isDisplayed) return translateString("legalBasis");
        if (state.doubleLegalBasis.isDisplayed) return translateString("doubleLegalBasis");
        if (state.nationalLaw.isDisplayed) return translateString("nationalLaw");
        return "";
    }

    function getDisplayedType(): AddToAllDialogType | null {
        if (state.directive.isDisplayed) return "directive";
        if (state.nationalLaw.isDisplayed) return "nationalLaw";
        if (state.doubleLegalBasis.isDisplayed) return "doubleLegalBasis";
        if (state.deletionPeriod.isDisplayed) return "deletionPeriod";
        return null;
    }

    function reset() {
        setState(createInitialState());
    }

    return {
        state,
        showDialogForType,
        hideDialog,
        isDialogVisible,
        getDialogType,
        getDisplayedType,
        reset,
    };
}
